import { type Context, createContext } from 'react';

type MorphContextValue = {
	isMorph?: boolean;
	isExpanding?: boolean;
	onIntrinsicContentChange?: (element: HTMLDivElement | null) => void;
};

export const RovoThinkingMorphContext: Context<MorphContextValue> =
	createContext<MorphContextValue>({});
